import { FC, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useGetOrCreateSupportChatMutation } from 'src/redux/api'
import { Loader } from 'src/components/ui'

const SupportRedirect: FC = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [getOrCreateSupportChat, { isError }] = useGetOrCreateSupportChatMutation()

  useEffect(() => {
    getOrCreateSupportChat()
      .unwrap()
      .then((chat) => {
        navigate(`/messenger/${chat.id}`, { replace: true })
      })
      .catch(() => {
        // 503 (no operators) or other failure — render the error UI below
      })
  }, [getOrCreateSupportChat, navigate])

  if (isError) {
    return (
      <div className="flex items-center justify-center min-h-[60vh] px-4">
        <p className="text-base text-ink-2 text-center max-w-md">{t('supportUnavailable')}</p>
      </div>
    )
  }

  return <Loader />
}

export default SupportRedirect
